export const splitSessionCodeByDash = (sessionId: string) => {
  return sessionId.replace(/(.{3})/g, '$1-').slice(0, -1);
};
